var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF4DE;}\n\t.st1{fill:#FE947A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 38.9
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,39.2c0,1.3-1.1,2.4-2.4,2.4h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h2.4 c1.3,0,2.4,1.1,2.4,2.4V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,51.2c0,1.3-1.1,2.4-2.4,2.4h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h2.4 c1.3,0,2.4,1.1,2.4,2.4V51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,63.2c0,1.3-1.1,2.4-2.4,2.4h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h2.4 c1.3,0,2.4,1.1,2.4,2.4V63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,39.2c0,1.3-1.1,2.4-2.4,2.4H45.2c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h21.5 c1.3,0,2.4,1.1,2.4,2.4V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,51.2c0,1.3-1.1,2.4-2.4,2.4H45.2c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h21.5 c1.3,0,2.4,1.1,2.4,2.4V51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,63.2c0,1.3-1.1,2.4-2.4,2.4H45.2c-1.3,0-2.4-1.1-2.4-2.4v-2.4c0-1.3,1.1-2.4,2.4-2.4h21.5 c1.3,0,2.4,1.1,2.4,2.4V63.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.7d61a0312c10c71d514d929eb843d73e.svg";
export { ForwardRef as ReactComponent };